var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2747 9.43711C13.3768 9.09513 12.9653 8.854 12.6473 9.01595C12.5496 9.06572 12.4497 9.11177 12.3478 9.15396C11.5784 9.47264 10.7318 9.55603 9.91504 9.39356C9.09826 9.23108 8.34799 8.83008 7.75911 8.2412C7.17024 7.65233 6.76922 6.90208 6.60676 6.08529C6.44429 5.2685 6.52769 4.42187 6.84637 3.65248C6.88857 3.55064 6.93462 3.45076 6.98439 3.35303C7.14632 3.03503 6.90519 2.62359 6.56321 2.72556C6.04931 2.8788 5.55835 3.10863 5.10761 3.40981C4.22044 4.00261 3.52895 4.84515 3.12063 5.83093C2.71231 6.81672 2.60546 7.90147 2.81362 8.94797C3.02178 9.99449 3.53559 10.9558 4.29008 11.7102C5.04457 12.4647 6.00586 12.9785 7.05236 13.1867C8.09886 13.3949 9.18359 13.288 10.1694 12.8797C11.1551 12.4714 11.9977 11.7799 12.5905 10.8927C12.8917 10.442 13.1216 9.95102 13.2747 9.43711Z",
    fill: "url(#paint0_linear_9848_4387)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2398 6.39087C12.1658 6.428 12.1058 6.48809 12.0688 6.56216L11.828 7.04373C11.7927 7.1144 11.6918 7.1144 11.6564 7.04373L11.4156 6.56216C11.3786 6.48809 11.3186 6.428 11.2446 6.39087L10.7628 6.14905C10.6922 6.11359 10.6924 6.01273 10.7631 5.9775L11.2439 5.73804C11.3183 5.70095 11.3787 5.64064 11.4159 5.56622L11.6564 5.08523C11.6918 5.01456 11.7927 5.01456 11.828 5.08523L12.0685 5.56622C12.1057 5.64064 12.1661 5.70095 12.2406 5.73803L12.7213 5.9775C12.7921 6.01273 12.7922 6.11359 12.7216 6.14905L12.2398 6.39087Z",
    fill: "url(#paint1_linear_9848_4387)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8896 3.7287C12.8341 3.75656 12.7891 3.80163 12.7613 3.85716L12.5807 4.21835C12.5542 4.27136 12.4786 4.27136 12.452 4.21835L12.2715 3.85716C12.2437 3.80163 12.1987 3.75656 12.1432 3.7287L11.7819 3.54733C11.7289 3.52075 11.729 3.4451 11.782 3.41867L12.1426 3.23907C12.1985 3.21125 12.2438 3.16603 12.2717 3.11022L12.452 2.74947C12.4786 2.69647 12.5542 2.69647 12.5807 2.74947L12.7611 3.11022C12.789 3.16603 12.8343 3.21125 12.8901 3.23907L13.2507 3.41867C13.3037 3.4451 13.3039 3.52075 13.251 3.54733L12.8896 3.7287Z",
    fill: "url(#paint2_linear_9848_4387)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.113 4.15658C10.0483 4.18909 9.99578 4.24167 9.96338 4.30645L9.7527 4.72783C9.72177 4.78968 9.63351 4.78968 9.60258 4.72783L9.3919 4.30645C9.3595 4.24167 9.30701 4.18909 9.24225 4.15658L8.82069 3.945C8.75888 3.91398 8.75902 3.82572 8.82092 3.79488L9.24159 3.58536C9.30675 3.55291 9.3596 3.50013 9.39216 3.43502L9.60258 3.01416C9.63351 2.95231 9.72177 2.95231 9.7527 3.01416L9.96313 3.43502C9.99568 3.50013 10.0485 3.55289 10.1137 3.58536L10.5344 3.79488C10.5963 3.82572 10.5964 3.91398 10.5346 3.945L10.113 4.15658Z",
    fill: "url(#paint3_linear_9848_4387)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9848_4387",
    x1: 2.70996,
    y1: 2.70972,
    x2: 13.2906,
    y2: 13.2904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73DBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9848_4387",
    x1: 10.71,
    y1: 5.03222,
    x2: 12.7745,
    y2: 7.09674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE39B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9848_4387",
    x1: 11.7422,
    y1: 2.70972,
    x2: 13.2906,
    y2: 4.2581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE39B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9848_4387",
    x1: 8.77442,
    y1: 2.96777,
    x2: 10.5809,
    y2: 4.77422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE39B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/MoonIcon.cd8de7d2f9d23f3318f87a66c27927de.svg";
export { ForwardRef as ReactComponent };